export enum ViewType {
	ProfileProbabilityView = 'profile_probability_view',
}
